// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1IptfCUnnPqffOjT2avgAS","tableWrapper":"_2DyPbgE1GkcRYS7QPKMekQ","tableWrapperResponsive":"_1L8fc5WdpJzt2NcPDDsvwe","col-full-site":"G5MU6GZiiwN2x9Z1SbHJf"};